import React, { useState } from "react";
import {
  useGetInsuranceMetaMutation,
  // useGetInsurancesMutation,
  useUpdateInsuranceMutation,
} from "../../../../features/patient/patientApiSlice";
import Loading from "../../../../components/Loading";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../features/auth/authSlice";
import { lobs, payers, POC_TYPE } from "../../../../constants/config.constants";
import StateManagedSelect from "react-select";

const InsuranceDetails = ({ patient, editable }) => {
  const user = useSelector(selectUser);
  const [isEditInsurance, setIsEditInsurance] = React.useState(false);
  const [insuranceDetails, setInsuranceDetails] = React.useState({
    insurancepackageid: "",
    insuranceidnumber: "",
    sequencenumber: "",
    policynumber: "",
    issuedate: "",
    expirationdate: "",
    updateappointments: false,
    lob: "",
    payer: "",
    subscriber_plan_id: "",
    member_health_plan_id: "",
    policyholderfirstname: "",
    policyholderlastname: "",
    policyholderdob: "",
    policyholdersex: "",
    policyholderaddress1: "",
    policyholderaddress2: "",
    policyholdercity: "",
    policyholderstate: "",
    policyholderzip: "",
    policyholdercountrycode: "",
    policyholderphone: "",
    policyholderemail: "",
    policyholdertype: "",
  });

  const [insuranceErrors, setInsuranceErrors] = React.useState({});
  const [payers, setPayers] = useState([]);

  const [lobs, setLobs] = useState([]);


  // const [insurances, setInsurances] = React.useState([]);

  const [updateInsurance, { isLoading: isUpdatingInsurance }] =
    useUpdateInsuranceMutation();
  const [insuranceMeta] = useGetInsuranceMetaMutation();
  // const [getInsurances] = useGetInsurancesMutation();

  // const fetchInsurance = async () => {
  //   const { data } = await getInsurances({
  //     practiceId: user.organisation.practiceId,
  //   }).unwrap();
  //   setInsurances(data);
  // };

  // React.useEffect(() => {
  //   fetchInsurance();
  // }, []);

  React.useEffect(() => {
    if (patient?.insurance?.[0]) {
      setInsuranceDetails(patient.insurance[0]);
    }
  }, [patient?.insurance]);

  const handleInsuranceChange = (e) => {
    const { name, value } = e.target;
    setInsuranceDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSelectChange = (field, selectedOption) => {
    if (field === 'lob') {
      setInsuranceDetails((prev) => ({
        ...prev,
        lob: selectedOption ? selectedOption.label : "",
        lob_id: selectedOption ? selectedOption.id : "",
      }));
    } else if (field === 'payer') {
      setInsuranceDetails((prev) => ({
        ...prev,
        payer: selectedOption ? selectedOption.label : "",
        payer_id: selectedOption ? selectedOption.id : "",
      }));
    }
  };
  const getInsuranceMetaData = async () => {
    try {
      // setLoadingMeta(true);
      const result = await insuranceMeta(user.organisation.id)?.unwrap();

      if (result?.data) {
        // Transform payers array to match expected format
        const transformedPayers = result.data.payers.map(payer => ({
          id: payer.id,
          value: payer.label, // Using label as value for dropdown
          label: payer.label
        }));

        // Transform lobs array to match expected format
        const transformedLobs = result.data.lobs.map(lob => ({
          id: lob.id,
          value: lob.label, // Using label as value for dropdown
          label: lob.label
        }));

        setPayers(transformedPayers);
        setLobs(transformedLobs);
      }
    } catch (error) {
      console.error("Error fetching insurance meta data:", error);
    } finally {
      // setLoadingMeta(false);
    }
  };

  const validateInsuranceForm = () => {
    const errors = {};
    const today = new Date();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?[\d\s-()]{10,}$/;
    const zipRegex = /^\d{5}(-\d{4})?$/;
    // Required field validations
    if (!String(insuranceDetails.insurancepackageid)?.trim()) {
      errors.insurancepackageid = "Insurance Package ID is required";
    }
    if (!String(insuranceDetails.insuranceidnumber)?.trim()) {
      errors.insuranceidnumber = "Insurance ID Number is required";
    }
    if (!String(insuranceDetails.policyholderfirstname)?.trim()) {
      errors.policyholderfirstname = "First name is required";
    }
    if (!String(insuranceDetails.policyholderlastname)?.trim()) {
      errors.policyholderlastname = "Last name is required";
    }
    if (!insuranceDetails.policyholderdob) {
      errors.policyholderdob = "Date of birth is required";
    }
    if (!insuranceDetails.policyholdersex) {
      errors.policyholdersex = "Gender is required";
    }
    if (!String(insuranceDetails.policyholderaddress1)?.trim()) {
      errors.policyholderaddress1 = "Street address is required";
    }
    if (!String(insuranceDetails.policyholdercity)?.trim()) {
      errors.policyholdercity = "City is required";
    }
    if (!String(insuranceDetails.policyholderstate)?.trim()) {
      errors.policyholderstate = "State is required";
    }
    if (!String(insuranceDetails.policyholderzip)?.trim()) {
      errors.policyholderzip = "ZIP code is required";
    } else if (!zipRegex.test(insuranceDetails.policyholderzip)) {
      errors.policyholderzip = "Invalid ZIP code format";
    }
    if (!String(insuranceDetails.policyholdercountrycode)?.trim()) {
      errors.policyholdercountrycode = "Country is required";
    }
    if (
      insuranceDetails.policyholderphone &&
      !phoneRegex.test(insuranceDetails.policyholderphone)
    ) {
      errors.policyholderphone = "Invalid phone number format";
    }
    if (
      insuranceDetails.policyholderemail &&
      !emailRegex.test(insuranceDetails.policyholderemail)
    ) {
      errors.policyholderemail = "Invalid email format";
    }
    if (!String(insuranceDetails.policyholdertype)?.trim()) {
      errors.policyholdertype = "Relationship is required";
    }

    // Date validations
    if (insuranceDetails.issuedate) {
      const issueDate = new Date(insuranceDetails.issuedate);
      if (issueDate > today) {
        errors.issuedate = "Issue date cannot be in the future";
      }
    } else {
      errors.issuedate = "Issue date is required";
    }

    if (insuranceDetails.expirationdate) {
      const expirationDate = new Date(insuranceDetails.expirationdate);
      if (expirationDate < today) {
        errors.expirationdate = "Expiration date cannot be in the past";
      }
      if (
        insuranceDetails.issuedate &&
        new Date(insuranceDetails.issuedate) > expirationDate
      ) {
        errors.expirationdate = "Expiration date must be after issue date";
      }
    }

    // Format validations
    if (
      insuranceDetails.sequencenumber &&
      !/^\d+$/.test(insuranceDetails.sequencenumber)
    ) {
      errors.sequencenumber = "Sequence number must contain only digits";
    }

    setInsuranceErrors(errors);
    console.log(errors, "errors");
    return Object.keys(errors).length === 0;
  };

  const handleInsuranceSave = async () => {
    const isInsuranceValid = validateInsuranceForm();
    if (isInsuranceValid) {
      const { createdAt, updatedAt, patientid, ...rest } = insuranceDetails;
      const {
        data: { data },
      } = await updateInsurance({
        insurance: {
          ...rest,
          expirationdate: insuranceDetails.expirationdate || undefined,
          policynumber: insuranceDetails.policynumber || undefined,
          lob: insuranceDetails.lob || undefined,
          payer: insuranceDetails.payer || undefined,
          subscriber_plan_id: insuranceDetails.subscriber_plan_id || undefined,
          insuranceidnumber: insuranceDetails.insuranceidnumber || undefined,
          updateappointments: insuranceDetails.updateappointments
            ? "Yes"
            : "No",
        },
        patientId: patient.id,
      });
      data && setInsuranceDetails(data);
      setIsEditInsurance(false);
      setInsuranceErrors({});
    }
  };

  const getSelectedLob = () => {
    return lobs.find(option => option.id === insuranceDetails.lob_id) || null;
  };

  const getSelectedPayer = () => {
    return payers.find(option => option.id === insuranceDetails.payer_id) || null;
  };

  React.useEffect(() => {
    getInsuranceMetaData();
  }, []);

  return (
    <div className="w-full">
      <div className="relative w-full overflow-x-auto overflow-y-auto p-6">
        {isUpdatingInsurance && <Loading loading={isUpdatingInsurance} />}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-bold">Insurance Details</h2>
          {user?.type === 1 && user?.details?.role === 1 && (
            <div className="flex flex-row items-center gap-2">
              {isEditInsurance && (
                <button
                  onClick={() => {
                    setIsEditInsurance(false);
                    setInsuranceErrors({});
                  }}
                  className="px-4 py-2 shadow-sm rounded-md border-[2px] border-primarygrayborder whitespace-nowrap text-primaryblue"
                >
                  Cancel
                </button>
              )}
              <button
                disabled={!editable}
                onClick={() => {
                  if (isEditInsurance) {
                    handleInsuranceSave();
                  } else {
                    setIsEditInsurance(true);
                  }
                }}
                className="px-4 py-2 shadow-sm rounded-md border-[2px] border-primarygrayborder whitespace-nowrap text-primaryblue disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isEditInsurance ? "Save" : "Edit"}
              </button>
            </div>
          )}
        </div>
        <div className="flex justify-end items-end">
          {isEditInsurance && Object.keys(insuranceErrors).length > 0 ? (
            <span className="text-sm text-red-500">
              Please fill all the required fields
            </span>
          ) : null}
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Policy Holder/Guarantor Name *
            </label>
            {isEditInsurance ? (
              <div className="grid grid-cols-2 gap-2">
                <input
                  type="text"
                  name="policyholderfirstname"
                  placeholder="First Name"
                  value={insuranceDetails.policyholderfirstname || ""}
                  disabled={!isEditInsurance}
                  onChange={handleInsuranceChange}
                  className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.policyholderfirstname
                    ? "border-red-500"
                    : "border-gray-300"
                    }`}
                />
                {insuranceErrors.policyholderfirstname && (
                  <span className="text-sm text-red-500">
                    {insuranceErrors.policyholderfirstname}
                  </span>
                )}
                <input
                  type="text"
                  name="policyholderlastname"
                  placeholder="Last Name"
                  value={insuranceDetails.policyholderlastname || ""}
                  disabled={!isEditInsurance}
                  onChange={handleInsuranceChange}
                  className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.policyholderlastname
                    ? "border-red-500"
                    : "border-gray-300"
                    }`}
                />
                {insuranceErrors.policyholderlastname && (
                  <span className="text-sm text-red-500">
                    {insuranceErrors.policyholderlastname}
                  </span>
                )}
              </div>
            ) : (
              <input
                type="text"
                name="name"
                value={`${insuranceDetails.policyholderfirstname ?? "NA"} ${insuranceDetails.policyholderlastname ?? ""
                  }`}
                disabled={!isEditInsurance}
                className="p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 border-gray-300"
              />
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Policy Holder/Guarantor DOB *
            </label>
            <input
              type="date"
              name="policyholderdob"
              value={
                insuranceDetails.policyholderdob
                  ? new Date(insuranceDetails.policyholderdob)
                    .toISOString()
                    .split("T")[0]
                  : "NA"
              }
              onChange={handleInsuranceChange}
              disabled={!isEditInsurance}
              className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${"border-gray-300"}`}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Policy Holder/Guarantor Gender *
            </label>
            <select
              name="policyholdersex"
              value={insuranceDetails.policyholdersex}
              disabled={!isEditInsurance}
              onChange={handleInsuranceChange}
              className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${"border-gray-300"}`}
            >
              <option value="">NA</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
            </select>
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Policy Holder/Guarantor Address *
            </label>
            {isEditInsurance ? (
              <div className="grid grid-cols-1 gap-2">
                <input
                  type="text"
                  name="policyholderaddress1"
                  placeholder="Street Address"
                  value={insuranceDetails.policyholderaddress1 || ""}
                  disabled={!isEditInsurance}
                  onChange={handleInsuranceChange}
                  className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.policyholderaddress1
                    ? "border-red-500"
                    : "border-gray-300"
                    }`}
                />
                {insuranceErrors.policyholderaddress1 && (
                  <span className="text-sm text-red-500">
                    {insuranceErrors.policyholderaddress1}
                  </span>
                )}
                <input
                  type="text"
                  name="policyholderaddress2"
                  placeholder="Apt, Suite, Unit, etc."
                  value={insuranceDetails.policyholderaddress2 || ""}
                  disabled={!isEditInsurance}
                  onChange={handleInsuranceChange}
                  className="p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 border-gray-300"
                />
                <div className="grid grid-cols-2 gap-2">
                  <input
                    type="text"
                    name="policyholdercity"
                    placeholder="City"
                    value={insuranceDetails.policyholdercity || ""}
                    disabled={!isEditInsurance}
                    onChange={handleInsuranceChange}
                    className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.policyholdercity
                      ? "border-red-500"
                      : "border-gray-300"
                      }`}
                  />
                  {insuranceErrors.policyholdercity && (
                    <span className="text-sm text-red-500">
                      {insuranceErrors.policyholdercity}
                    </span>
                  )}
                  <input
                    type="text"
                    name="policyholderstate"
                    placeholder="State"
                    value={insuranceDetails.policyholderstate || ""}
                    disabled={!isEditInsurance}
                    onChange={handleInsuranceChange}
                    className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.policyholderstate
                      ? "border-red-500"
                      : "border-gray-300"
                      }`}
                  />
                  {insuranceErrors.policyholderstate && (
                    <span className="text-sm text-red-500">
                      {insuranceErrors.policyholderstate}
                    </span>
                  )}
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <input
                    type="text"
                    name="policyholderzip"
                    placeholder="ZIP Code"
                    value={insuranceDetails.policyholderzip || ""}
                    disabled={!isEditInsurance}
                    onChange={handleInsuranceChange}
                    className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.policyholderzip
                      ? "border-red-500"
                      : "border-gray-300"
                      }`}
                  />
                  {insuranceErrors.policyholderzip && (
                    <span className="text-sm text-red-500">
                      {insuranceErrors.policyholderzip}
                    </span>
                  )}
                  <input
                    type="text"
                    name="policyholdercountrycode"
                    placeholder="Country"
                    value={insuranceDetails.policyholdercountrycode || ""}
                    disabled={!isEditInsurance}
                    onChange={handleInsuranceChange}
                    className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.policyholdercountrycode
                      ? "border-red-500"
                      : "border-gray-300"
                      }`}
                  />
                  {insuranceErrors.policyholdercountrycode && (
                    <span className="text-sm text-red-500">
                      {insuranceErrors.policyholdercountrycode}
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <input
                type="text"
                name="policyholderaddress"
                value={
                  [
                    insuranceDetails.policyholderaddress1,
                    insuranceDetails.policyholderaddress2,
                    insuranceDetails.policyholdercity,
                    insuranceDetails.policyholderstate,
                    insuranceDetails.policyholderzip,
                    insuranceDetails.policyholdercountrycode,
                  ]
                    .filter(Boolean)
                    .join(", ") || "NA"
                }
                disabled={!isEditInsurance}
                className="p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 border-gray-300"
              />
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Patient Relationship to Policy Holder/Guarantor *
            </label>
            <StateManagedSelect
              name="type"
              options={Object.keys(POC_TYPE)
                .map((type) => ({ value: type, label: POC_TYPE[type] }))
                .sort((a, b) => a.label.localeCompare(b.label))}
              value={
                Object.keys(POC_TYPE)
                  .map((type) => ({ value: type, label: POC_TYPE[type] }))
                  .sort((a, b) => a.label.localeCompare(b.label))
                  .find(
                    (option) =>
                      option.value === insuranceDetails.policyholdertype
                  ) || null
              }
              onChange={(selectedOption) =>
                handleInsuranceChange({
                  target: {
                    name: "type",
                    value: selectedOption ? selectedOption.value : "",
                  },
                })
              }
              isDisabled={!isEditInsurance}
              placeholder="NA"
              isClearable
              className="rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 border-gray-300"
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Policy Holder/Guarantor Phone *
            </label>
            <input
              type="text"
              name="policyholderphone"
              value={
                insuranceDetails.policyholderphone ??
                (!isEditInsurance ? "NA" : "")
              }
              disabled={!isEditInsurance}
              onChange={handleInsuranceChange}
              className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${"border-gray-300"}`}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Policy Holder/Guarantor Email
            </label>
            <input
              type="text"
              name="policyholderemail"
              value={
                insuranceDetails.policyholderemail ??
                (!isEditInsurance ? "NA" : "")
              }
              disabled={!isEditInsurance}
              onChange={handleInsuranceChange}
              className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${"border-gray-300"}`}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Insurance Package ID *
            </label>
            <input
              name="insurancepackageid"
              id="insurancepackageid"
              className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.insurancepackageid
                ? "border-red-500"
                : "border-gray-300"
                }`}
              value={insuranceDetails.insurancepackageid}
              disabled={true}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Insurance ID/Member Health Plan ID *
            </label>
            <input
              type="text"
              name="insuranceidnumber"
              value={insuranceDetails.insuranceidnumber || "NA"}
              onChange={handleInsuranceChange}
              disabled={!isEditInsurance}
              className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.insuranceidnumber
                ? "border-red-500"
                : "border-gray-300"
                }`}
            />
            {insuranceErrors.insuranceidnumber && (
              <span className="text-sm text-red-500">
                {insuranceErrors.insuranceidnumber}
              </span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Sequence Number
            </label>
            <select
              name="sequencenumber"
              id="sequencenumber"
              className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.sequencenumber
                ? "border-red-500"
                : "border-gray-300"
                }`}
              value={insuranceDetails.sequencenumber}
              disabled={!isEditInsurance}
              onChange={handleInsuranceChange}
            >
              <option value="">NA</option>
              <option value="1">Primary</option>
              <option value="2">Secondary</option>
            </select>
            {insuranceErrors.sequencenumber && (
              <span className="text-sm text-red-500">
                {insuranceErrors.sequencenumber}
              </span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Policy Number
            </label>
            <input
              type="text"
              name="policynumber"
              value={insuranceDetails.policynumber || "NA"}
              onChange={handleInsuranceChange}
              disabled={!isEditInsurance}
              className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.policynumber
                ? "border-red-500"
                : "border-gray-300"
                }`}
            />
            {insuranceErrors.policynumber && (
              <span className="text-sm text-red-500">
                {insuranceErrors.policynumber}
              </span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Issue Date *
            </label>
            <input
              type="date"
              name="issuedate"
              value={insuranceDetails.issuedate}
              onChange={handleInsuranceChange}
              disabled={!isEditInsurance}
              className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.issuedate ? "border-red-500" : "border-gray-300"
                }`}
            />
            {insuranceErrors.issuedate && (
              <span className="text-sm text-red-500">
                {insuranceErrors.issuedate}
              </span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Expiration Date
            </label>
            <input
              type="date"
              name="expirationdate"
              value={insuranceDetails.expirationdate}
              onChange={handleInsuranceChange}
              disabled={!isEditInsurance}
              className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.expirationdate
                ? "border-red-500"
                : "border-gray-300"
                }`}
            />
            {insuranceErrors.expirationdate && (
              <span className="text-sm text-red-500">
                {insuranceErrors.expirationdate}
              </span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">LOB *</label>
            {isEditInsurance ? <StateManagedSelect
              name="lob"
              // options={lobs
              //   .map((lob) => ({ value: lob, label: lob }))
              //   .sort((a, b) => a.label.localeCompare(b.label))}
              // value={
              //   lobs
              //     .map((lob) => ({ value: lob, label: lob }))
              //     .sort((a, b) => a.label.localeCompare(b.label))
              //     .find(
              //       (option) =>
              //         option?.value?.toLowerCase() ===
              //         insuranceDetails?.lob?.toLowerCase()
              //     ) || null
              // }
              options={lobs.sort((a, b) => a.label.localeCompare(b.label))}
              value={getSelectedLob()}
              onChange={(selectedOption) => handleSelectChange('lob', selectedOption)}
              isDisabled={!isEditInsurance}
              placeholder="NA"
              isClearable
              className="rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 border-gray-300"
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            /> : <p className="rounded-md outline-none bg-gray-100 ring-gray-300 border-gray-300 m-0 p-2">{getSelectedLob()?.label}</p>}
            {insuranceErrors.lob && (
              <span className="text-sm text-red-500">
                {insuranceErrors.lob}
              </span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Payer *
            </label>
            {isEditInsurance ? <StateManagedSelect
              name="payer"
              // options={payers
              //   .map((payer) => ({ value: payer, label: payer }))
              //   .sort((a, b) => a.label.localeCompare(b.label))}
              // value={
              //   payers
              //     .map((payer) => ({ value: payer, label: payer }))
              //     .sort((a, b) => a.label.localeCompare(b.label))
              //     .find((option) => option.value === insuranceDetails.payer) ||
              //   null
              // }
              options={payers.sort((a, b) => a.label.localeCompare(b.label))}
              value={getSelectedPayer()}
              // onChange={(selectedOption) =>
              //   // handleInsuranceChange({
              //   //   target: {
              //   //     name: "payer",
              //   //     value: selectedOption ? selectedOption.value : "",
              //   //   },
              //   // })

              // }
              onChange={(selectedOption) => handleSelectChange('payer', selectedOption)}
              isDisabled={!isEditInsurance}
              placeholder="NA"
              isClearable
              className="rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 border-gray-300"
              menuPortalTarget={document.body}
              menuPlacement="top" // Add this line to open upwards
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            /> : <p className="rounded-md outline-none bg-gray-100 ring-gray-300 border-gray-300 m-0 p-2">{getSelectedPayer()?.label}</p>}
            {insuranceErrors.payer && (
              <span className="text-sm text-red-500">
                {insuranceErrors.payer}
              </span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700">
              Subscriber Plan ID *
            </label>
            <input
              type="text"
              name="subscriber_plan_id"
              value={insuranceDetails.subscriber_plan_id ?? "NA"}
              disabled={!isEditInsurance}
              onChange={handleInsuranceChange}
              className={`p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primaryblue disabled:bg-gray-100 ${insuranceErrors.subscriber_plan_id
                ? "border-red-500"
                : "border-gray-300"
                }`}
            />
            {insuranceErrors.subscriber_plan_id && (
              <span className="text-sm text-red-500">
                {insuranceErrors.subscriber_plan_id}
              </span>
            )}
          </div>
          {isEditInsurance && (
            <div className="flex items-center gap-2">
              <label className="text-sm font-semibold text-gray-700">
                Update appointments
              </label>
              <input
                type="checkbox"
                name="updateappointments"
                checked={insuranceDetails.updateappointments}
                onChange={(e) => {
                  setInsuranceDetails((prev) => ({
                    ...prev,
                    updateappointments: e.target.checked,
                  }));
                }}
                className="w-4 h-4"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InsuranceDetails;
